import { createSlice } from "@reduxjs/toolkit";
import { extendSliceWithAssignees } from "slices/assignees/utils";

import { TAB_VIEW_LIST } from "../../constants/miscAnalysis";

export const initialState = {
  listData: [],
  isListInitialized: false,
  currentMiscAnalysis: null,
  isCurrentLoading: false,
  currentViewTab: TAB_VIEW_LIST,
  selectedRowIndex: -1,
  searchQuery: "",
  sortColumn: "name",
  sortOrder: "ASC",
  showCreatePanel: false,
  showEditPanel: false,
  editingMiscAnalysis: null,
};

export const miscAnalysisSlice = createSlice({
  name: "miscAnalysis",
  initialState,
  reducers: {
    reset: () => initialState,
    setListData: (state, action) => {
      state.listData = action.payload;
    },
    setIsListInitialized: (state, action) => {
      state.isListInitialized = action.payload;
    },
    setCurrentMiscAnalysis: (state, action) => {
      state.currentMiscAnalysis = action.payload;
    },
    ...extendSliceWithAssignees({
      rootPath: "currentMiscAnalysis",
      actionName: "setMiscAnalysisAssignees",
    }),
    setIsCurrentLoading: (state, action) => {
      state.isCurrentLoading = action.payload;
    },
    setCurrentViewTab: (state, action) => {
      state.currentViewTab = action.payload;
    },
    setSelectedRowIndex: (state, action) => {
      state.selectedRowIndex = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortOrder: (state, action) => {
      state.sortOrder = action.payload;
    },
    setShowCreatePanel: (state, action) => {
      state.showCreatePanel = action.payload;
    },
    setShowEditPanel: (state, action) => {
      state.showEditPanel = action.payload;
    },
    setEditingMiscAnalysis: (state, action) => {
      state.editingMiscAnalysis = action.payload;
    },
    addMiscAnalysisToList: (state, action) => {
      state.listData = [action.payload, ...state.listData];
    },
    updateMiscAnalysisInList: (state, action) => {
      const index = state.listData.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.listData[index] = action.payload;
      }
    },
    removeMiscAnalysisFromList: (state, action) => {
      state.listData = state.listData.filter(
        (item) => item.id !== action.payload
      );
    },
  },
});

export const {
  reset,
  setListData,
  setIsListInitialized,
  setCurrentMiscAnalysis,
  setMiscAnalysisAssignees,
  setIsCurrentLoading,
  setCurrentViewTab,
  setSelectedRowIndex,
  setSearchQuery,
  setSortColumn,
  setSortOrder,
  setShowCreatePanel,
  setShowEditPanel,
  setEditingMiscAnalysis,
  addMiscAnalysisToList,
  updateMiscAnalysisInList,
  removeMiscAnalysisFromList,
} = miscAnalysisSlice.actions;

export default miscAnalysisSlice.reducer;
